import React, { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import { Form, Row, Col, Image, Button, Table, Modal } from "react-bootstrap";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  IconButton,
  MenuItem,
} from "@material-ui/core";
import SimpleReactLightbox from "simple-react-lightbox";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Toggle } from "../../../../components/superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import Scrollbars from "react-custom-scrollbars";
import SwitchMt from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";

import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import { useFormik } from "formik";
import * as yup from "yup";
//import { AmealioLoader } from "../../../Loader/AmealioLoader";
import moment from "moment";
import axios from "axios";
import {
  serverApi,
  videoUploadSize,
  imageUploadSize,
} from "../../../../config/Keys";
import Alert from "react-s-alert";
import Switch from "react-switch";
import MultipleImageUploadComponent from "../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import AlertDialogProgress from "../../../reusableComponents/allPopupReusable/DialogProgression";
import InputNumberFunc from "../../../../function/InputNumberFunc";
import MapSetupEvent from "../../../vendorOnboradingComponents/allScreens/MapSetup/MapSetupEvent";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { vendor_update_events } from "../../../../store/actions/vendorOffersAndEventsAction";
import { ToggleButtonWithYesNo } from "../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/AllButton/ToggleButtonReuse";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ReusableOnboardingButton } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import isEmpty from "../../../../store/validation/is-Empty";

const VendorEditOfflineEvent = (props) => {
  let history = useHistory();
  const [checked, setChecked] = useState(false);
  const [FloorsSection, setFloorsSection] = useState(false);
  const [selectedTab, setSelectedTab] = useState(1);
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const toggleFunction = (e) => {
    // setChecked({ checked: !checked.checked });
    formik1.setFieldValue("isKidsAllowed", !formik1.values.isKidsAllowed);
  };

  const [primaryOffer, setPrimaryOffer] = useState(false);
  const markAsPrimary = (data) => (e) => {
    // setPrimaryOffer({ primaryOffer: !primaryOffer.primaryOffer });
    if (data === false) {
      setPrimaryOffer({ primaryOffer: true });
      setactive({ active: true });
    } else {
      setPrimaryOffer({ primaryOffer: !primaryOffer.primaryOffer });
    }
  };

  const thumbnail = true;

  const [active, setactive] = useState({ active: false });
  const statusChange = (e) => {
    setactive({ active: !active.active });
  };

  const [state, setState] = useState({
    eventTags: [],
    eventTagsText: "",
    minAge: 18,
    restaurant_pictures: [],
    restaurant_pictures_new: [],
    restaurant_video: [],
    video_url: "",
    isRSVP_autoAccept: false,
    highchair: false,
    handicap_access: false,
    room_on_seating_rq: false,
    progress: 0,
    actionButton: false,
    floor_numberArr: [],
    floor_seat: [],
    floor_table: [],
    bookingEnabled: false,
    errors: {},
  });
  const selecthandleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const handleToggleFloorsSection = (e) => {
    setFloorsSection({
      FloorsSection: !FloorsSection.FloorsSection,
    });
  };

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/
  const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);
  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = formik1.values.photos;
    let newData = e;
    let mergedData = oldData.concat(newData);
    formik1.setFieldValue("photos", mergedData);
    if (thumbnail) {
      let thumbData = formik1.values?.photo_thumbnails;
      let url = e.split("/");
      url.splice(url.length - 1, 0, "thumbnail");
      url = url.join("/");
      thumbData = thumbData.concat(url);
      formik1.setFieldValue("photo_thumbnails", thumbData);
    }
    let restaurant_pictures_temp = restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };
  const cancelFiles = (file) => {
    let restaurant_pictures_temp = formik1.values.photos;
    let newToUpload = restaurant_pictures_temp.filter((item) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };
  const bankUploadMultipleFiles = (e) => {
    if (formik1.values.photos.length + e.target.files.length > 6) {
      Alert.error(`<h4>Cannot upload  more than 6 images</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const vendor_id = props.auth.user.VendorUser._id;
      let restaurant_name;
      if (props.onboarding.restaurant_name) {
        restaurant_name = props.onboarding.restaurant_name.split(" ").join("");
      } else {
        restaurant_name = "";
      }
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      var newUploaded = [];
      var docs = false;
      for (let i = 0; i < e.target.files.length; i++) {
        let allPicures = formik1.values.photos;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            flag = true;
          }
        });
        if (!flag) {
          if (e.target.files[i].type === "application/pdf") {
            docs = true;
            data.append("files", e.target.files[i]);
          } else {
            newUploaded.push(e.target.files[i]);
          }
        }
      }
      if (!flag) {
        setResPicNew(newUploaded);
        setCombined(combined);
        if (docs) {
          axios
            .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
            .then((res) => {
              let oldData = formik1.values.photos;
              let newData = res.data;
              let mergedData = oldData.concat(newData);
              formik1.setFieldValue("photos", mergedData);
              Alert.success(`<h4>Image Upload Successfully</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            })
            .catch((err) => {
              Alert.error(`<h4>${err}</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            });
        }
      } else {
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const bankDocMultipleRemove = (indexId) => {
    let allImages = formik1.values.photos.filter((item, index) => {
      return index !== indexId;
    });
    let thumbImage = formik1.values.photo_thumbnails.filter((item, index) => {
      return index !== indexId;
    });
    formik1.setFieldValue("photos", allImages);
    formik1.setFieldValue("photo_thumbnails", thumbImage);
  };

  // /*************************************
  //  * @DESC Multiple Image Upload
  //  ************************************/

  // const onCompleteUploadMultipleCrop = (e, file) => {
  //   let oldData = state.restaurant_pictures;
  //   let restaurant_pictures_temp = state.restaurant_pictures_new;

  //   let newToUpload = restaurant_pictures_temp.filter((item, index) => {
  //     return item.name !== file.name;
  //   });
  //   oldData.push(e);
  //   setState({
  //     ...state,
  //     restaurant_pictures_new: newToUpload,
  //     restaurant_pictures: oldData,
  //     actionButton: true,
  //   });
  // };
  // const uploadMultipleFiles = (e) => {
  //   const vendor_id = props.auth.user.VendorUser._id;
  //   const restaurant_name = props.onboarding.restaurant_name
  //     .split(" ")
  //     .join("");
  //   const combined = vendor_id + "_" + restaurant_name;
  //   const data = new FormData();
  //   let flag = false;
  //   var newUploaded = [];
  //   for (let i = 0; i < e.target.files.length; i++) {
  //     if (e.target.files[i].size > imageUploadSize) {
  //       alert("File is too Big");
  //       return (flag = false);
  //     } else if (e.target.files.length > 10) {
  //       alert("You can upload only 10 files");
  //       return (flag = false);
  //     } else {
  //       let allPicures = state.restaurant_pictures;
  //       allPicures.some((phone) => {
  //         if (
  //           phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
  //         ) {
  //           return (flag = true);
  //         } else {
  //           return (flag = false);
  //         }
  //       });
  //       if (!flag) {
  //         newUploaded.push(e.target.files[i]);
  //         data.append("files", e.target.files[i]);
  //       }
  //     }
  //   }
  //   if (!flag) {
  //     setState({
  //       ...state,
  //       restaurant_pictures_new: newUploaded,
  //       combined: combined,
  //     });
  //   } else {
  //     Alert.error(`<h4>Can not upload the same image</h4>`, {
  //       position: "top-right",
  //       effect: "bouncyflip",
  //       beep: true,
  //       html: true,
  //       timeout: 3000,
  //       offset: 35,
  //     });
  //   }
  //   e.target.value = "";
  // };
  // const multipleResetFile = (indexId) => {
  //   let allPicures = state.restaurant_pictures;
  //   let allPicuresObj = allPicures.find((images, index) => index === indexId);
  //   if (allPicuresObj === 0 || allPicuresObj) {
  //     allPicures.splice(allPicures.indexOf(allPicuresObj), 1);
  //     setState({ ...state, allPicures: allPicures, actionButton: true });
  //   }
  // };

  /*************************************
   * @DESC Multiple Video Upload
   ************************************/
  const uploadMultipleVideoFiles = (e) => {
    e.preventDefault();
    const vendor_id = props.auth.user.VendorUser._id;
    const restaurant_name = props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > videoUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else {
        if (state.restaurant_video && state.restaurant_video.length > 0) {
          if (state.restaurant_video[0].name === e.target.files[i].name) {
            return (flag = true);
          }
        }
        if (!flag) {
          data.append("file", e.target.files[i]);
        }
      }
    }
    var newData = e.target.files;
    if (!flag) {
      const setProgress = (percent) => {
        setState({ ...state, progress: percent });
      };
      axios
        .post(`${serverApi}/upload-assets-video`, data, {
          onUploadProgress: (progressEvent) => {
            setProgress((progressEvent.loaded / progressEvent.total) * 100);
          },
        })
        .then((res) => {
          setState({
            ...state,
            restaurant_video: newData,
            video_url: res.data,
            actionButton: true,
          });
          Alert.success(`<h4>Restaurant Video Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      Alert.error(`<h4>Can not upload the same video</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };
  const multipleVideoResetFile = (e) => {
    let video_url = state.video_url;
    let restaurant_video = state.restaurant_video;
    video_url = "";
    restaurant_video = [];
    setState({
      ...state,
      restaurant_video: restaurant_video,
      video_url: video_url,
      actionButton: true,
    });
  };

  /*******************************
   * Add eventTags Action
   ******************************/
  const addeventTagsAction = (e) => {
    e.preventDefault();
    let eventTagsText = state.eventTagsText;
    let eventTags = state.eventTags;
    if (eventTagsText === "") {
      const { errors } = state;
      errors.eventTagsText = "Event tags is Required";
      setState({
        ...state,
        errors: errors,
      });
    } else if (eventTags.some((diner) => diner === eventTagsText)) {
      Alert.error(`<h4>Event tags Already Exits</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      eventTags.push(eventTagsText);
      setState({
        ...state,
        eventTags: eventTags,
        eventTagsText: "",
      });
    }
  };

  /*************************************
   * @DESC eventTags Change Handlers
   ************************************/
  const oneventTagsChangeHandler = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
      actionButton: true,
      errors: {},
    });
  };

  /*************************************
   * @DESC Remove eventTags Change Handlers
   ************************************/
  const removeeventTagsAction = (indexId) => (e) => {
    let eventTags = state.eventTags;
    let eventTagsObj = eventTags.find((images, index) => index === indexId);
    if (eventTagsObj === 0 || eventTagsObj) {
      eventTags.splice(eventTags.indexOf(eventTagsObj), 1);
      setState({
        ...state,
        eventTags: eventTags,
      });
    }
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
    object.target.value =
      !!object.target.value && Math.abs(object.target.value) >= 0
        ? Math.abs(object.target.value)
        : 0;
  };

  /*************************************
   * @DESC Remove TaxName Change Handlers
   ************************************/
  const removeFloorAndSection = () => {
    let letFloorData = formik4.values.floors;
    let letTableData = formik4.values.table;
    let letSeatData = formik4.values.seat;

    // code for removing table
    let removeFloorData;
    removeFloorData = letFloorData.filter((item, index) => {
      return activeIndex !== index;
    });

    // code for removing data from table array  added for that floor number and area

    let removeDataForFloorArea = [];
    for (let i = 0; i < letTableData.length; i++) {
      if (
        letTableData[i].floor_number === floorNumber &&
        letTableData[i].area === areaNo
      ) {
        // dont append this data as we should delete this from table array
      } else {
        removeDataForFloorArea.push(letTableData[i]);
      }
    }

    // code for removing data from seat array  added for that floor number and area

    let removeDataForSeatArea = [];
    for (let i = 0; i < letSeatData.length; i++) {
      if (
        letSeatData[i].floor_number === floorNumber &&
        letSeatData[i].area === areaNo
      ) {
        // dont append this data as we should delete this from table array
      } else {
        removeDataForSeatArea.push(letSeatData[i]);
      }
    }
    setFloorNo("");
    setAreaNo("");
    handleCloseDeleteItem();
    if (formik4.values.floors.length === 1) {
      formik4.setFieldValue("floors", removeFloorData);
      formik4.setFieldValue("table", removeDataForFloorArea);
      formik4.setFieldValue("seat", removeDataForSeatArea);
      formik4.setFieldValue(
        "ticket_seat_selection",
        !formik4.values.ticket_seat_selection
      );
    } else {
      formik4.setFieldValue("floors", removeFloorData);
      formik4.setFieldValue("table", removeDataForFloorArea);
      formik4.setFieldValue("seat", removeDataForSeatArea);
    }
  };

  const [activeIndex, setActiveIndex] = useState();
  const [deleteItem, setDeleteItem] = useState(false);
  const [floorNumber, setFloorNo] = useState("");
  const [areaNo, setAreaNo] = useState("");
  const handleCloseDeleteItem = () => setDeleteItem(false);
  const handleshowDeleteItem = (index, floorNo, area) => {
    setActiveIndex(index);
    setFloorNo(floorNo);
    setAreaNo(area);
    setDeleteItem(true);
  };

  const onClickEditFloorArea = (data, index) => {
    setActiveIndex(index);
    formikAddNewFloorSeats.setFieldValue("floor_number", data.floor_number);
    formikAddNewFloorSeats.setFieldValue("area", data.area);
    setFloorNo(data.floor_number);
    setAreaNo(data.area);
  };

  const [showHide, setShowHide] = useState(true);

  const onClickAddFloor = (e) => {
    e.preventDefault();
    formikAddNewFloorSeats.handleSubmit();
  };

  const formikAddNewFloorSeats = useFormik({
    initialValues: {
      floor_number: "",
      area: "",
    },
    validationSchema: yup.object({
      floor_number: yup.string().required("Please enter floor number "),
      area: yup.string().required("Please enter section name / area "),
    }),

    onSubmit: (values) => {
      let floorData = formik4.values.floors;
      let checkItemExists = false;
      for (let i = 0; i < floorData.length; i++) {
        if (
          values.floor_number === floorData[i].floor_number &&
          values.area === floorData[i].area
        ) {
          checkItemExists = true;
          Alert.error(`<h4>You have already added this area /section</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        }
      }

      if (!checkItemExists) {
        if (activeIndex >= 0) {
          floorData[activeIndex] = values;
        } else {
          floorData.push(values);
        }
        formik4.setFieldValue("floors", floorData);
        formikAddNewFloorSeats.resetForm();
        setActiveIndex();
        setFloorNo("");
        setAreaNo("");
      }
    },
  });

  const venueLocation = (data) => {
    formik1.setFieldValue("venue", data);
  };

  const formik1 = useFormik({
    initialValues: {
      name: "",
      description: "",
      mark_as_primary: false,
      active: false,
      isKidsAllowed: false,
      minAge: "",
      isOnline: false,
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      venue_address: "",
      venue: {
        latitude: "",
        longitude: "",
      },
      photos: [],
      photo_thumbnails: [],
      videos: [],
      terms_and_condition: "",
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .required("Event name is required")
        .min(1, "Minimum 1 Character")
        .max(64, "Maximum 64 Character"),
      description: yup
        .string()
        .required("Description is required")
        .min(1, "Minimum 1 Character")
        .max(512, "Maximum 512 Character"),
      start_date: yup.string().required("Start date is required"),
      start_time: yup.string().required("Start time is required"),
      end_date: yup.string().required("End date is required"),
      end_time: yup.string().required("End time is required"),
      venue_address: yup
        .string()
        .required("Terms and condtion  is required")
        .min(1, "Minimum 1 Character")
        .max(512, "Maximum 512 Character"),
      terms_and_condition: yup
        .string()
        .required("Terms and condtion  is required")
        .min(1, "Minimum 1 Character")
        .max(512, "Maximum 512 Character"),
    }),

    onSubmit: (values) => {
      handleTab(2);
      // props.vendor_create_new_events(formData, token, onSuccess);
    },
  });

  const formik2 = useFormik({
    initialValues: {
      maxGuest_RSVP: "",
      buffer_RSVP_guest: "",
      min_people_RSVP: "",
      max_people_RSVP: "",
    },
    validationSchema: yup.object({
      maxGuest_RSVP: yup
        .number()
        .required("Maximum number of guests is required")
        .notOneOf([0], "Not a valid number!"),
      min_people_RSVP: yup
        .number()
        .required("Minimum number of people is required")
        .notOneOf([0], "Not a valid number!"),
      max_people_RSVP: yup
        .number()
        .required("Maximum number of people is required")
        .notOneOf([0], "Not a valid number!"),
      // buffer_RSVP_guest: yup
      //   .number()
      //   .required("Buffer number of guests is required"),
    }),

    onSubmit: (values) => {
      if (values.max_people_RSVP < values.min_people_RSVP) {
        formik2.setFieldError(
          "max_people_RSVP",
          "Maximum people rsvp always grater than or equal to minimum people rsvp"
        );
      } else {
        if (editData?.ticket_booking_subscription) {
          handleTab(3);
        } else {
          handleTab(5);
        }
      }
    },
  });

  const formik3 = useFormik({
    initialValues: {
      ticketName: "",
      adult_price: "",
      child_price: "",
      total_quantity_TB: "",
      buffer_TB_guest: "",
      min_people_per_booking: "",
      max_people_per_booking: "",
      ticket_description: "",
      refund_and_cancellation: "",
      ticket_booking_subscription: false,
    },
    validationSchema: yup.object({
      ticketName: yup
        .string()
        .required("Terms and condtion  is required")
        .min(1, "Minimum 1 Character")
        .max(100, "Maximum 512 Character"),
      adult_price: yup
        .number()
        .required("Adult price is required")
        .notOneOf([0], "Not a valid number!"),
      // child_price: yup.number().required("Child price is required"),
      total_quantity_TB: yup
        .number()
        .required("Total quantity is required")
        .notOneOf([0], "Not a valid number!"),
      min_people_per_booking: yup
        .number()
        .required("Min people per booking is required")
        .notOneOf([0], "Not a valid number!"),
      max_people_per_booking: yup
        .number()
        .required("Max people per booking is required")
        .notOneOf([0], "Not a valid number!"),
      ticket_description: yup
        .string()
        .required("Ticket description is required")
        .min(1, "Minimum 1 Character")
        .max(512, "Maximum 512 Character"),
      refund_and_cancellation: yup
        .string()
        .required("Refund and cancellation is required")
        .min(1, "Minimum 1 Character")
        .max(512, "Maximum 512 Character"),
    }),
    onSubmit: (values) => {
      if (values.max_people_per_booking < values.min_people_per_booking) {
        formik3.setFieldError(
          "max_people_per_booking",
          "Maximum people rsvp always grater than or equal to minimum people rsvp"
        );
      } else {
        handleTab(4);
      }
    },
  });

  const formik4 = useFormik({
    initialValues: {
      floors: [],
      seat: [],
      table: [],
      ticket_seat_selection: false,
    },

    onSubmit: (values) => {
      // if (values.floors.length === 0) {
      //   Alert.error(`<h4>Please add atleast one floor/seat section</h4>`, {
      //     position: "top-right",
      //     effect: "bouncyflip",
      //     beep: true,
      //     html: true,
      //     timeout: 3000,
      //     offset: 35,
      //   });
      // } else {
      handleTab(5);
      // }
    },
  });

  const formik5 = useFormik({
    initialValues: {
      auto_accept_pax: "",
    },
    validationSchema: yup.object({
      auto_accept_pax: yup.number().notOneOf([0], "Not a valid number!"),
    }),

    onSubmit: (values) => {
      const startDate = {
        start_date: moment(
          formik1.values.start_date + "T" + formik1.values.start_time
        ).valueOf(),
      };
      const end_Date = {
        end_date: moment(
          formik1.values.end_date + "T" + formik1.values.end_time
        ).valueOf(),
      };

      values.start = startDate.start_date;
      values.end = end_Date.end_date;
      values.vendor_id = props.auth.user.VendorUser._id;

      // if (checked.checked === false) {
      //   formik1.values.isKidsAllowed = false;
      //   formik1.values.minAge = state.minAge;
      // } else {
      //   formik1.values.isKidsAllowed = true;
      //   formik1.values.minAge = "";
      // }

      if (primaryOffer.primaryOffer) {
        formik1.values.mark_as_primary = true;
      }

      if (active.active) {
        formik1.values.active = true;
      }

      let token = props.auth.user.accessToken;
      const offerId = editData?._id;
      let formData = {
        name: formik1.values.name,
        description: formik1.values.description,
        mark_as_primary: formik1.values.mark_as_primary,
        start_date: values.start,
        end_date: values.end,
        // photos: state.restaurant_pictures,
        // photo_thumbnails: state.restaurant_pictures,
        photos: formik1.values.photos,
        photo_thumbnails: formik1.values.photo_thumbnails,
        active: formik1.values.active,
        venue_address: formik1.values.venue_address,
        location: {
          type: "Point",
          coordinates: [
            formik1.values.venue.longitude,
            formik1.values.venue.latitude,
          ],
        },
        venue: formik1.values.venue,
        vendor_id: values.vendor_id,
        isOnline: false,
        isKidsAllowed: formik1.values.isKidsAllowed,
        minAge: formik1.values.minAge,
        videos: state.video_url === "" ? [] : state.video_url,
        eventTags: state.eventTags,
        terms_and_condition: formik1.values.terms_and_condition,
        isRSVP_autoAccept: state.isRSVP_autoAccept,
        maxGuest_RSVP: formik2.values.maxGuest_RSVP,
        seat_selection_applicable: formik4.values.ticket_seat_selection,
        buffer_RSVP_guest: formik2.values.buffer_RSVP_guest,
        min_people_RSVP: formik2.values.min_people_RSVP,
        max_people_RSVP: formik2.values.max_people_RSVP,
        ticketName: formik3.values.ticketName,
        adult_price: formik3.values.adult_price,
        child_price: formik3.values.child_price,
        total_quantity_TB: formik3.values.total_quantity_TB,
        buffer_TB_guest: formik3.values.buffer_TB_guest,
        min_people_per_booking: formik3.values.min_people_per_booking,
        max_people_per_booking: formik3.values.max_people_per_booking,
        ticket_description: formik3.values.ticket_description,
        ticket_booking_subscription: formik3.values.ticket_booking_subscription,
        refund_and_cancellation: formik3.values.refund_and_cancellation,
        table_setup: {
          floors: formik4.values.floors,
          seat: state.floor_seat,
          table: state.floor_table,
        },
        highchair: state.highchair,
        handicap_access: state.handicap_access,
        room_on_seating_rq: state.room_on_seating_rq,
        auto_accept_pax: values.auto_accept_pax,
        point_of_entry: "VENDOR",
      };
      if (formData.auto_accept_pax < formik2.values.min_people_RSVP) {
        formik5.setFieldError(
          "auto_accept_pax",
          `Auto pax limit should not be less than minimum people of rsvp value`
        );
      } else if (formData.auto_accept_pax > formik2.values.max_people_RSVP) {
        formik5.setFieldError(
          "auto_accept_pax",
          `Auto pax limit should not be greater than maximum people of rsvp value`
        );
      } else {
        onClickFloorsDataSet(formData, token, offerId);
      }
    },
  });

  const onClickFloorsDataSet = (formData, token, offerId) => {
    const seatingAreaSeat = filteredSeatDataDashboard;
    const allInputData = formik4.values.floors;
    var floorToFilter = [];
    setState({
      ...state,
      floor_seat: [],
    });
    var finalData = [];
    for (let i = 0; i < allInputData.length; i++) {
      floorToFilter.push(allInputData[i].floor_number);
    }
    seatingAreaSeat.map((item) => {
      if (floorToFilter.includes(item.floor_number)) {
        finalData.push(item);
        state.floor_seat.push(item);
      }
    });
    formData.table_setup.seat = finalData;
    props.vendor_update_events(formData, offerId, token, onEventSuccess);
  };

  const onEventSuccess = (e) => {
    Alert.success("<h4>Event Update Successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/event");
  };

  const [minDate, setMinDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");
  const handleStartDateChange = (e) => {
    formik1.setFieldValue("start_date", e.target.value);
    formik1.setFieldValue("end_date", "");
    setMinEndDate(e.target.value);
  };
  useEffect(() => {
    let data = moment().format("YYYY-MM-DD");
    setMinDate(data);
  }, []);

  const [count, setCount] = useState(1);
  const onClickFome1Save = () => {
    setCount(count + 1);
    formik1.handleSubmit();
  };
  const onClickFome2Save = () => {
    setCount(count + 1);
    formik2.handleSubmit();
  };
  const onClickFome3Save = () => {
    setCount(count + 1);
    formik3.handleSubmit();
  };
  const onClickFome4Save = () => {
    setCount(count + 1);
    formik4.handleSubmit();
  };
  const onClickFome5Save = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik5.handleSubmit();
  };

  useEffect(() => {
    if (history.location && history.location.state) {
      setEditData(history.location.state.editData);
    }
  }, [history.location && history.location.state]);

  const [editData, setEditData] = useState({});

  useEffect(() => {
    if (editData?.photos) {
      formik1.setFieldValue("photos", editData?.photos);
    }
    if (editData?.photo_thumbnails) {
      formik1.setFieldValue("photo_thumbnails", editData?.photo_thumbnails);
    }
    if (editData?.name) {
      formik1.setFieldValue("name", editData?.name);
    }
    if (editData?.description) {
      formik1.setFieldValue("description", editData?.description);
    }
    if (editData?.start_date) {
      let startD = editData?.start_date.split("T")[0];
      formik1.setFieldValue(`start_date`, startD);
      let startT = moment(editData?.start_date).format("HH:mm");
      formik1.setFieldValue(`start_time`, startT);
    }
    if (editData?.end_date) {
      let endD = editData?.end_date.split("T")[0];
      formik1.setFieldValue(`end_date`, endD);
      let endT = moment(editData?.end_date).format("HH:mm");
      formik1.setFieldValue(`end_time`, endT);
    }
    if (editData?.venue_address) {
      formik1.setFieldValue("venue_address", editData?.venue_address);
    }
    if (editData?.terms_and_condition) {
      formik1.setFieldValue(
        "terms_and_condition",
        editData?.terms_and_condition
      );
    }

    if (editData?.table_setup && editData?.table_setup.floors) {
      formik4.setFieldValue("floors", editData?.table_setup.floors);
    }
    if (editData?.table_setup && editData?.table_setup.seat) {
      formik4.setFieldValue("seat", editData?.table_setup.seat);
    }
    if (editData?.table_setup && editData?.table_setup.table) {
      formik4.setFieldValue("table", editData?.table_setup.table);
    }

    if (editData && editData?.eventTags) {
      setState({
        ...state,
        eventTags: !isEmpty(editData?.eventTags) ? editData?.eventTags : [],
        restaurant_pictures: !isEmpty(editData?.photos) ? editData?.photos : [],
        video_url: !isEmpty(editData?.videos) ? editData?.videos : "",
        isRSVP_autoAccept: !isEmpty(editData?.isRSVP_autoAccept)
          ? editData?.isRSVP_autoAccept
          : false,
        highchair: !isEmpty(editData?.highchair) ? editData?.highchair : false,
        handicap_access: !isEmpty(editData?.handicap_access)
          ? editData?.handicap_access
          : false,
        room_on_seating_rq: !isEmpty(editData?.room_on_seating_rq)
          ? editData?.room_on_seating_rq
          : false,
        floor_seat: !isEmpty(editData?.table_setup)
          ? editData?.table_setup?.seat
          : [],
        floor_table: !isEmpty(editData?.table_setup)
          ? editData?.table_setup?.table
          : [],
      });
    }

    if (editData && editData?.isKidsAllowed) {
      // setChecked({ checked: editData?.isKidsAllowed });
      formik1.setFieldValue("isKidsAllowed", editData?.isKidsAllowed);
    } else {
      formik1.setFieldValue("isKidsAllowed", editData?.isKidsAllowed);
      formik1.setFieldValue("minAge", editData?.minAge);
    }

    if (editData && editData?.mark_as_primary) {
      setPrimaryOffer({ primaryOffer: editData?.mark_as_primary });
    }
    if (editData && editData?.active) {
      setactive({ active: editData?.active });
    }
    if (editData?.maxGuest_RSVP) {
      formik2.setFieldValue("maxGuest_RSVP", editData?.maxGuest_RSVP);
    }
    if (editData?.buffer_RSVP_guest) {
      formik2.setFieldValue("buffer_RSVP_guest", editData?.buffer_RSVP_guest);
    }
    if (editData?.min_people_RSVP) {
      formik2.setFieldValue("min_people_RSVP", editData?.min_people_RSVP);
    }
    if (editData?.max_people_RSVP) {
      formik2.setFieldValue("max_people_RSVP", editData?.max_people_RSVP);
    }
    if (editData?.seat_selection_applicable) {
      formik4.setFieldValue(
        "ticket_seat_selection",
        editData?.seat_selection_applicable
      );
    }
    if (editData?.ticketName) {
      formik3.setFieldValue("ticketName", editData?.ticketName);
    }
    if (editData?.adult_price) {
      formik3.setFieldValue("adult_price", editData?.adult_price);
    }
    if (editData?.child_price) {
      formik3.setFieldValue("child_price", editData?.child_price);
    }
    if (editData?.total_quantity_TB) {
      formik3.setFieldValue("total_quantity_TB", editData?.total_quantity_TB);
    }
    if (editData?.buffer_TB_guest) {
      formik3.setFieldValue("buffer_TB_guest", editData?.buffer_TB_guest);
    }
    formik3.setFieldValue(
      "ticket_booking_subscription",
      editData?.ticket_booking_subscription
    );
    if (editData?.min_people_per_booking) {
      formik3.setFieldValue(
        "min_people_per_booking",
        editData?.min_people_per_booking
      );
    }
    if (editData?.max_people_per_booking) {
      formik3.setFieldValue(
        "max_people_per_booking",
        editData?.max_people_per_booking
      );
    }
    if (editData?.ticket_description) {
      formik3.setFieldValue("ticket_description", editData?.ticket_description);
    }
    if (editData?.refund_and_cancellation) {
      formik3.setFieldValue(
        "refund_and_cancellation",
        editData?.refund_and_cancellation
      );
    }

    if (editData?.auto_accept_pax) {
      formik5.setFieldValue("auto_accept_pax", editData?.auto_accept_pax);
    }
  }, [editData]);

  useEffect(() => {
    if (
      props.subscriptionData &&
      props.subscriptionData.casual_dining === true
    ) {
      setState({
        ...state,
        floor_numberArr: !isEmpty(
          props.subscriptionData &&
            props.subscriptionData.casual_dining_status &&
            props.subscriptionData.casual_dining_status.seating &&
            props.subscriptionData.casual_dining_status.seating
              .table_management &&
            props.subscriptionData.casual_dining_status.seating.table_management
              .table_setup &&
            props.subscriptionData.casual_dining_status.seating.table_management
              .table_setup.floors
        )
          ? props.subscriptionData &&
            props.subscriptionData.casual_dining_status &&
            props.subscriptionData.casual_dining_status.seating &&
            props.subscriptionData.casual_dining_status.seating
              .table_management &&
            props.subscriptionData.casual_dining_status.seating.table_management
              .table_setup &&
            props.subscriptionData.casual_dining_status.seating.table_management
              .table_setup.floors
          : [],
        bookingEnabled: !isEmpty(
          props.subscriptionData?.casual_dining_status?.event_management
            ?.offline_event?.booking_enabled?.value
        )
          ? props.subscriptionData?.casual_dining_status?.event_management
              ?.offline_event?.booking_enabled?.value
          : "",
      });
    }
  }, [props.subscriptionData]);

  const selectHandleChange = (e) => {
    formikAddNewFloorSeats.setFieldValue("floor_number", e.target.value);
  };

  const selectHandleChange2 = (e) => {
    formikAddNewFloorSeats.setFieldValue("area", e.target.value);
  };

  const [viewSeatingArea, setViewSeatingArea] = useState(false);
  const handleViewSeatingArea = (e) => {
    setViewSeatingArea(!viewSeatingArea);
  };

  const [filteredTableDataDashboard, setFilteredTableDataDashboard] = useState(
    []
  );
  const [filteredSeatDataDashboard, setFilteredSeatDataDashboard] = useState(
    []
  );

  useEffect(() => {
    if (
      props.subscriptionData &&
      props.subscriptionData.casual_dining === true
    ) {
      setFilteredTableDataDashboard(
        !isEmpty(
          props.subscriptionData &&
            props.subscriptionData.casual_dining_status &&
            props.subscriptionData.casual_dining_status.seating &&
            props.subscriptionData.casual_dining_status.seating
              .table_management &&
            props.subscriptionData.casual_dining_status.seating.table_management
              .table_setup &&
            props.subscriptionData.casual_dining_status.seating.table_management
              .table_setup.table
        )
          ? props.subscriptionData &&
              props.subscriptionData.casual_dining_status &&
              props.subscriptionData.casual_dining_status.seating &&
              props.subscriptionData.casual_dining_status.seating
                .table_management &&
              props.subscriptionData.casual_dining_status.seating
                .table_management.table_setup &&
              props.subscriptionData.casual_dining_status.seating
                .table_management.table_setup.table
          : []
      );
      setFilteredSeatDataDashboard(
        !isEmpty(
          props.subscriptionData &&
            props.subscriptionData.casual_dining_status &&
            props.subscriptionData.casual_dining_status.seating &&
            props.subscriptionData.casual_dining_status.seating
              .table_management &&
            props.subscriptionData.casual_dining_status.seating.table_management
              .table_setup &&
            props.subscriptionData.casual_dining_status.seating.table_management
              .table_setup.seat
        )
          ? props.subscriptionData &&
              props.subscriptionData.casual_dining_status &&
              props.subscriptionData.casual_dining_status.seating &&
              props.subscriptionData.casual_dining_status.seating
                .table_management &&
              props.subscriptionData.casual_dining_status.seating
                .table_management.table_setup &&
              props.subscriptionData.casual_dining_status.seating
                .table_management.table_setup.seat
          : []
      );
    }
  }, [props.subscriptionData]);

  const onModalTableData = () => {
    const seatingAreaSeat = filteredSeatDataDashboard;
    // const seatingAreaTable = filteredTableDataDashboard;
    // const result = [...seatingAreaSeat, ...seatingAreaTable];
    // Array.prototype.push.apply(seatingAreaSeat, seatingAreaTable);
    let filtereddata = [];
    if (
      formikAddNewFloorSeats.values.floor_number ===
        formikAddNewFloorSeats.values.floor_number &&
      formikAddNewFloorSeats.values.area === formikAddNewFloorSeats.values.area
    ) {
      // filtereddata = result.filter(
      //   (data) =>
      //     data.floor_number === formikAddNewFloorSeats.values.floor_number ||
      //     data.area === formikAddNewFloorSeats.values.area
      // );
      filtereddata =
        seatingAreaSeat &&
        seatingAreaSeat.filter(
          (data) =>
            data.floor_number === formikAddNewFloorSeats.values.floor_number ||
            data.area === formikAddNewFloorSeats.values.area
        );
    } else {
      // filtereddata = result;
      filtereddata = seatingAreaSeat;
    }
    if (!isEmpty(filtereddata)) {
      return filtereddata.map((item, index) => (
        <tr key={index}>
          <td>
            <div className="f12-400">{item.floor_number}</div>
          </td>
          <td>
            <div className="f12-400">{item.area}</div>
          </td>
          <td>
            <div className="f12-400">
              {/* {item.table_number} */}
              {item.seat_number}
            </div>
          </td>
          <td>
            {item.shape === "Square" ? (
              <Image
                src={require("../../../../assets/images/UserManagement/square.svg")}
                alt="square"
                title="square"
                width="33px"
                height="19px"
              />
            ) : (
              <> </>
            )}

            {item.shape === "Rectangle" ? (
              <Image
                src={require("../../../../assets/images/UserManagement/rectangle.svg")}
                alt="Rectangle"
                title="Rectangle"
                width="33px"
                height="19px"
              />
            ) : (
              <> </>
            )}

            {item.shape === "Circle" ? (
              <Image
                src={require("../../../../assets/images/UserManagement/circle.svg")}
                alt="Circle"
                title="Circle"
                width="33px"
                height="19px"
              />
            ) : (
              <> </>
            )}
          </td>
          <td>
            <div className="f12-400"> {item.pax_value}</div>
          </td>
          <td>
            <div className="f12-400">{item.location}</div>
          </td>
          <td>
            <span
              className={` ${
                item.status === "AVAILABLE" ? "enGreenDot" : "enYellowDot"
              }`}
            ></span>
          </td>
        </tr>
      ));
    }
  };

  const onClickSeatSelectionAction = () => {
    if (formik4.values.floors.length === 0) {
      Alert.error(
        `<h4>If you enable this service please add floor & Section</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
    } else {
      formik4.setFieldValue(
        "ticket_seat_selection",
        !formik4.values.ticket_seat_selection
      );
    }
  };

  const AntSwitch = withStyles((theme) => ({
    root: {
      width: 41,
      height: 15,
      padding: 0,
      display: "flex",
      overflow: "inherit",
    },
    switchBase: {
      padding: 2,
      color: "#212121",
      top: "-6px",
      left: "-5px",
      "&$checked": {
        transform: "translateX(20px)",
        color: "rgb(89, 248, 50)",
        "& + $track": {
          opacity: 1,
          backgroundColor: "rgb(238, 238, 238)",
          borderColor: "rgb(238, 238, 238)",
        },
      },
    },
    thumb: {
      width: 24,
      height: 24,
      boxShadow: "none",
    },
    track: {
      border: `1px solid rgb(238, 238, 238)`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: "rgb(238, 238, 238)",
    },
    checked: {},
  }))(SwitchMt);

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={2} />
          </div>
          <div className="super-admin-right-side-panel">
            <div className="super-admin-inside-right-side-panel">
              <RightSideNavigation />
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Edit Event</div>
              </div>
              <div className="d-flex align-items-start">
                <div className={`enAddOffersOPtion `}>
                  <Image
                    src={require("../../../../assets/images/UserManagement/offlineActiveOffer.svg")}
                    alt="View"
                    title="View"
                    fluid
                    className="ml-3"
                  />
                  <span className="text-red f12-400 d-block w-100 mb-2">
                    Offline Event
                  </span>
                  <span className="w-100 f9-400 d-block">
                    (Note: Events are in a physical venue and you can even
                    accept RSVP)
                  </span>
                </div>
              </div>
              <hr />
              <div className="d-flex align-items-center">
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    selectedTab === 1 ? "active" : ""
                  }`}
                >
                  General Information
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    selectedTab === 2 ? "active" : ""
                  }`}
                >
                  RSVP
                </Button>
                {editData?.ticket_booking_subscription ? (
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${
                      selectedTab === 3 ? "active" : ""
                    }`}
                  >
                    Ticket Booking
                  </Button>
                ) : null}
                {editData?.ticket_booking_subscription ? (
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${
                      selectedTab === 4 ? "active" : ""
                    }`}
                  >
                    Seating
                  </Button>
                ) : null}
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    selectedTab === 5 ? "active" : ""
                  }`}
                >
                  Other Settings
                </Button>
              </div>
              {selectedTab === 1 && (
                <Form>
                  <Row className="pt-4">
                    <Col lg={8}>
                      <Form.Group>
                        <TextField
                          id="name"
                          label="Event Name"
                          type="text"
                          variant="outlined"
                          className={`w-100 ${
                            formik1.errors.name && formik1.touched.name
                              ? "enError"
                              : ""
                          }`}
                          name="name"
                          onChange={formik1.handleChange}
                          value={formik1.values.name}
                          onBlur={formik1.handleBlur}
                        />
                        {formik1.errors.name && formik1.touched.name ? (
                          <div className="pho_14_regular text-danger">
                            {formik1.errors.name}
                          </div>
                        ) : null}
                      </Form.Group>
                      <Form.Group>
                        <TextField
                          id="description"
                          label="Description"
                          type="text"
                          multiline
                          rows="5"
                          variant="outlined"
                          className={`w-100 ${
                            formik1.errors.description &&
                            formik1.touched.description
                              ? "enError"
                              : ""
                          }`}
                          name="description"
                          onChange={formik1.handleChange}
                          value={formik1.values.description}
                          onBlur={formik1.handleBlur}
                          //onInvalid={formik1.errors.email && formik1.touched.email}
                        />
                        {formik1.errors.description &&
                        formik1.touched.description ? (
                          <div className="pho_14_regular text-danger">
                            {formik1.errors.description}
                          </div>
                        ) : null}
                      </Form.Group>
                      <Row className="pb-4">
                        <Col lg={6}>
                          <div className="f12-400 pb-2">
                            (Fill out the details, event are used offline)
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="d-flex align-items-start">
                            <Switch
                              onChange={markAsPrimary(
                                primaryOffer.primaryOffer
                              )}
                              checked={primaryOffer.primaryOffer}
                              offColor="#EEEEEE"
                              onColor="#EEEEEE"
                              offHandleColor="#212121"
                              onHandleColor="#59F832"
                              handleDiameter={24}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={15}
                              width={41}
                              boxShadow="-2px 0px 5px #0000003B"
                              activeBoxShadow="-2px 0px 5px #0000003B"
                              id="material-switch"
                            />
                            <div className="pl-2">
                              <div className="f12-500 mb-2">
                                Make this Event Primary
                              </div>
                              <div className="f10-400">
                                (Note you can make only one Offer primary, by
                                making this offer primary it will remove primary
                                from other active offers)
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <hr />
                      <Row className="pb-4">
                        <Col lg={2}>
                          <div className="f16-500">Status</div>
                        </Col>
                        <Col lg={3} className="d-flex">
                          <div
                            className={`${
                              active.active === false ? "f14-500" : "f14-400"
                            }`}
                          >
                            InActive
                          </div>
                          <div className="d-flex align-items-start ml-2 mr-2">
                            <Switch
                              onChange={statusChange}
                              checked={active.active}
                              offColor="#EEEEEE"
                              onColor="#EEEEEE"
                              offHandleColor="#212121"
                              onHandleColor="#59F832"
                              handleDiameter={24}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={15}
                              width={41}
                              boxShadow="-2px 0px 5px #0000003B"
                              activeBoxShadow="-2px 0px 5px #0000003B"
                              id="material-switch"
                            />
                          </div>
                          <div
                            className={`${
                              active.active ? "f14-500" : "f14-400"
                            }`}
                          >
                            Active
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12}>
                      <hr />

                      <div className="f16-500 py-1">Allow Kids?</div>
                      <div className="f10-400 pb-4">
                        (This may be relevant if you are a Bar and Night Club
                        with min age to enter, you may still have to check the
                        ID for the entrants)
                      </div>
                      <Row className="align-items-center pb-3">
                        <Col md={3}>
                          <div className="f14-400 text-dark">Kids Allowed</div>
                        </Col>
                        <Col md={9}>
                          <div className="d-flex align-items-center">
                            <div className="f12-400 mr-2">No</div>
                            <Toggle
                              checked={formik1.values.isKidsAllowed}
                              toggleFunction={toggleFunction}
                            />
                            <div className="f12-400 ml-2">Yes</div>
                          </div>
                        </Col>
                      </Row>
                      {formik1.values.isKidsAllowed ? (
                        <></>
                      ) : (
                        <Row className="align-items-center pb-3">
                          <Col md={3}>
                            <div className="f14-400 text-dark">
                              Min Age for Entry
                            </div>
                          </Col>
                          <Col md={9}>
                            <FormControl variant="outlined" className={"w134"}>
                              <Select
                                value={formik1.values.minAge}
                                onChange={formik1.handleChange}
                                inputProps={{
                                  name: "minAge",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <option value={18}>18</option>
                                <option value={21}>21</option>
                              </Select>
                            </FormControl>
                          </Col>
                        </Row>
                      )}
                      <hr className="mb-5" />
                      <Row className="pb-4">
                        <Col md={3}>
                          <TextField
                            label="Event Tags"
                            variant="outlined"
                            className="w-100"
                            name="eventTagsText"
                            onChange={oneventTagsChangeHandler}
                            value={state.eventTagsText}
                          ></TextField>
                          <div className="text-red f12-400 mt-1 mb-1">
                            {state.errors.eventTagsText}
                          </div>
                          <div className="opacity5 f10-400">
                            Events tag is used for user app for search
                          </div>
                        </Col>
                        <Col className="pt-2">
                          <Button
                            variant="link"
                            className="d-flex align-items-center p-0 mb-4"
                            onClick={addeventTagsAction}
                          >
                            <Image
                              src={require("../../../../assets/images/UserManagement/add-blue.svg")}
                              alt="add"
                              title="add"
                              className="w-20px"
                            />
                            <span className="ml-2 f12-500 text-blue">Add</span>
                          </Button>
                        </Col>
                        <Col md={12}>
                          <div className="d-flex flex-wrap mt-2">
                            {state.eventTags &&
                              state.eventTags.map((data, index) => {
                                return (
                                  <div className="mb-3 mr-3" key={index}>
                                    <div className="keywords_button">
                                      <p>{data}</p>
                                      <span
                                        className="ml-2"
                                        onClick={removeeventTagsAction(index)}
                                      >
                                        <SVG
                                          src={require("../../../../assets/images/UserManagement/close.svg")}
                                        />
                                      </span>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </Col>
                      </Row>
                      <Row className="pb-4 align-items-center">
                        <Col md={3} xl={2} className="my-2">
                          <TextField
                            id="start_date"
                            label="Start Date"
                            variant="outlined"
                            InputProps={{
                              inputProps: { min: minDate },
                            }}
                            type="date"
                            defaultValue={minDate}
                            className={`w-100 ${
                              formik1.errors.start_date &&
                              formik1.touched.start_date
                                ? "enError"
                                : ""
                            }`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="start_date"
                            onChange={(e) => handleStartDateChange(e)}
                            //onChange={formik1.handleChange}
                            value={formik1.values.start_date}
                            onBlur={formik1.handleBlur}
                          />
                          {formik1.errors.start_date &&
                          formik1.touched.start_date ? (
                            <div className="pho_14_regular text-danger">
                              {formik1.errors.start_date}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} xl={2} className="my-2">
                          <TextField
                            id="start_time"
                            label="Start Time"
                            variant="outlined"
                            type="time"
                            className={`w-100 ${
                              formik1.errors.start_time &&
                              formik1.touched.start_time
                                ? "enError"
                                : ""
                            }`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="start_time"
                            onChange={formik1.handleChange}
                            value={formik1.values.start_time}
                            onBlur={formik1.handleBlur}
                          />
                          {formik1.errors.start_time &&
                          formik1.touched.start_time ? (
                            <div className="pho_14_regular text-danger">
                              {formik1.errors.start_time}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} xl={2} className="my-2">
                          <TextField
                            id="end_date"
                            label="End Date"
                            variant="outlined"
                            InputProps={{
                              inputProps: { min: minEndDate },
                            }}
                            type="date"
                            className={`w-100 ${
                              formik1.errors.end_date &&
                              formik1.touched.end_date
                                ? "enError"
                                : ""
                            }`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="end_date"
                            onChange={formik1.handleChange}
                            value={formik1.values.end_date}
                            onBlur={formik1.handleBlur}
                          />
                          {formik1.errors.end_date &&
                          formik1.touched.end_date ? (
                            <div className="pho_14_regular text-danger">
                              {formik1.errors.end_date}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} xl={2} className="my-2">
                          <TextField
                            id="end_time"
                            label="End Time"
                            variant="outlined"
                            type="time"
                            className={`w-100 ${
                              formik1.errors.end_time &&
                              formik1.touched.end_time
                                ? "enError"
                                : ""
                            }`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="end_time"
                            onChange={formik1.handleChange}
                            value={formik1.values.end_time}
                            onBlur={formik1.handleBlur}
                          />
                          {formik1.errors.end_time &&
                          formik1.touched.end_time ? (
                            <div className="pho_14_regular text-danger">
                              {formik1.errors.end_time}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={8}>
                          <Form.Group>
                            <TextField
                              id="venue_address"
                              label="Venue/Adress/Location"
                              type="text"
                              multiline
                              rows="5"
                              variant="outlined"
                              className={`w-100 ${
                                formik1.errors.venue_address &&
                                formik1.touched.venue_address
                                  ? "enError"
                                  : ""
                              }`}
                              name="venue_address"
                              onChange={formik1.handleChange}
                              value={formik1.values.venue_address}
                              onBlur={formik1.handleBlur}
                            />
                            {formik1.errors.venue_address &&
                            formik1.touched.venue_address ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.venue_address}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Col lg={8}>
                        <MapSetupEvent
                          handleLocation={venueLocation}
                          editAction={true}
                        />
                      </Col>
                      <hr />
                      <div className="event-offer-image">
                        <SimpleReactLightbox>
                          <MultipleImageUploadComponent
                            title="Add Photos*"
                            // smallTitle="(You can upload maximum 5 pic per event 700 x 420 pixels)"
                            onChange={bankUploadMultipleFiles}
                            //stateValue={bank_informaion}
                            cancelFiles={cancelFiles}
                            stateValue={formik1.values.photos}
                            newUploaded={
                              restaurant_pictures_new
                                ? restaurant_pictures_new
                                : []
                            }
                            combined={combined}
                            onCompleteUploadMultipleCrop={
                              onCompleteUploadMultipleCrop
                            }
                            removeImage={bankDocMultipleRemove}
                            accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                            thumbnail={thumbnail}
                            // onChange={uploadMultipleFiles}
                            // stateValue={
                            //   state.restaurant_pictures &&
                            //   state.restaurant_pictures
                            // }
                            // newUploaded={
                            //   state.restaurant_pictures_new
                            //     ? state.restaurant_pictures_new
                            //     : []
                            // }
                            // combined={state.combined}
                            // onCompleteUploadMultipleCrop={
                            //   onCompleteUploadMultipleCrop
                            // }
                            // removeImage={multipleResetFile}
                            // accept="image/gif,image/jpeg,image/jpg,image/png"
                            // loader={state.multipleImageLoader}
                          />
                          <div className="font_12_r c_gray mb-4 d-flex">
                            (You can upload maximum 5 pic per event 700 x 420
                            pixels)
                          </div>
                        </SimpleReactLightbox>
                      </div>
                      <hr />
                      <div className="event-offer-image">
                        <SimpleReactLightbox>
                          <MultipleImageUploadComponent
                            title="Add Video"
                            // smallTitle="( Add Videos or 360 view of Business Establishment - If needed you can get a professional photo shoot or video to make it attractive - this will appear on user app)"
                            onChange={uploadMultipleVideoFiles}
                            stateValue={
                              state.video_url === "" ? [] : [state.video_url]
                            }
                            const
                            removeImage={multipleVideoResetFile}
                            accept="video/*"
                            singleUpload={true}
                            videoUpload={true}
                          />
                          <div className="font_12_r c_gray mb-4 d-flex">
                            (You can upload only 1 pic per offer 700 x 420
                            pixels)
                          </div>
                        </SimpleReactLightbox>
                        {!state.progress && state.progress === 0 ? null : (
                          <AlertDialogProgress
                            progress={state.progress}
                            title="Video Uploading..."
                          />
                        )}
                      </div>
                      <Row>
                        <Col lg={8}>
                          <Form.Group>
                            <TextField
                              id="terms_and_condition"
                              label="Terms and Conditions"
                              type="text"
                              multiline
                              rows="5"
                              variant="outlined"
                              className={`w-100 ${
                                formik1.errors.terms_and_condition &&
                                formik1.touched.terms_and_condition
                                  ? "enError"
                                  : ""
                              }`}
                              name="terms_and_condition"
                              onChange={formik1.handleChange}
                              value={formik1.values.terms_and_condition}
                              onBlur={formik1.handleBlur}
                            />
                            {formik1.errors.terms_and_condition &&
                            formik1.touched.terms_and_condition ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.terms_and_condition}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                      </Row>
                      <div className="py-4 d-flex align-items-center">
                        <Button
                          variant="outline-secondary"
                          className="btn-lg mr-4 px-5 btn150px"
                          type="button"
                          onClick={() => history.push("/event")}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="danger"
                          className="btn-lg px-5 btn150px"
                          type="button"
                          onClick={() => onClickFome1Save()}
                        >
                          Next
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
              {selectedTab === 2 && (
                <Form>
                  <div className="f16-500 text-dark mt-4">
                    RSVP is applicable to free events or to be paid on arrival
                  </div>
                  <Row className="pt-4">
                    <Col lg={12}>
                      <Row className="align-items-center pb-3">
                        <Col md={3} className="mt-3 mb-4">
                          <div className="f16-500 text-dark">Auto Accept</div>
                        </Col>
                        <Col md={9}>
                          <div className="d-flex align-items-center">
                            <div
                              className={`${
                                !state.isRSVP_autoAccept ? "f12-500" : "f12-400"
                              } mr-2`}
                            >
                              No
                            </div>
                            <Switch
                              onChange={() =>
                                setState({
                                  ...state,
                                  isRSVP_autoAccept: !state.isRSVP_autoAccept,
                                })
                              }
                              checked={state.isRSVP_autoAccept}
                              offColor="#EEEEEE"
                              onColor="#EEEEEE"
                              offHandleColor="#212121"
                              onHandleColor="#59F832"
                              handleDiameter={24}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={15}
                              width={41}
                              boxShadow="-2px 0px 5px #0000003B"
                              activeBoxShadow="-2px 0px 5px #0000003B"
                              id="material-switch"
                            />
                            <div
                              className={`${
                                state.isRSVP_autoAccept ? "f12-500" : "f12-400"
                              } ml-2`}
                            >
                              Yes
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="pb-4">
                        <Col md={4}>
                          <NewInputText
                            extraClass="mb-1"
                            name="maxGuest_RSVP"
                            maxLength={5}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onInput={maxLengthCheck}
                            inputType="number"
                            onKeyDown={InputNumberFunc}
                            onFocusOut={formik2.handleBlur}
                            onChange={formik2.handleChange}
                            value={formik2.values.maxGuest_RSVP}
                            labelText="Maximum Number of Guests"
                            controlClass="maxGuest_RSVP"
                          />
                          {formik2.errors.maxGuest_RSVP &&
                          formik2.touched.maxGuest_RSVP ? (
                            <div className="pho_14_regular text-danger">
                              {formik2.errors.maxGuest_RSVP}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={4} className="mobile-mt-1">
                          <NewInputText
                            extraClass="mb-1"
                            name="buffer_RSVP_guest"
                            maxLength={5}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onInput={maxLengthCheck}
                            inputType="number"
                            onKeyDown={InputNumberFunc}
                            onFocusOut={formik2.handleBlur}
                            onChange={formik2.handleChange}
                            value={formik2.values.buffer_RSVP_guest}
                            labelText="Buffer Number of Guests"
                            controlClass="buffer_RSVP_guest"
                          />
                          {formik2.errors.buffer_RSVP_guest &&
                          formik2.touched.buffer_RSVP_guest ? (
                            <div className="pho_14_regular text-danger">
                              {formik2.errors.buffer_RSVP_guest}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                      <Row className="pb-4">
                        <Col md={4}>
                          <NewInputText
                            extraClass="mb-1"
                            name="min_people_RSVP"
                            maxLength={5}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onInput={maxLengthCheck}
                            inputType="number"
                            onKeyDown={InputNumberFunc}
                            onFocusOut={formik2.handleBlur}
                            onChange={formik2.handleChange}
                            value={formik2.values.min_people_RSVP}
                            labelText="Minimum number of people"
                            controlClass="min_people_RSVP"
                          />
                          {formik2.errors.min_people_RSVP &&
                          formik2.touched.min_people_RSVP ? (
                            <div className="pho_14_regular text-danger">
                              {formik2.errors.min_people_RSVP}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={4} xs={12} className="mobile-mt-1">
                          <NewInputText
                            extraClass="mb-1"
                            name="max_people_RSVP"
                            maxLength={5}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onInput={maxLengthCheck}
                            inputType="number"
                            onKeyDown={InputNumberFunc}
                            onFocusOut={formik2.handleBlur}
                            onChange={formik2.handleChange}
                            value={formik2.values.max_people_RSVP}
                            labelText="Maximum number of people"
                            controlClass="max_people_RSVP"
                          />
                          {formik2.errors.max_people_RSVP &&
                          formik2.touched.max_people_RSVP ? (
                            <div className="pho_14_regular text-danger">
                              {formik2.errors.max_people_RSVP}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                      <div className="py-4 d-flex align-items-center">
                        <Button
                          variant="outline-secondary"
                          className="btn-lg mr-4 px-5 btn150px"
                          type="button"
                          onClick={() => handleTab(1)}
                        >
                          Back
                        </Button>
                        <Button
                          variant="danger"
                          className="btn-lg px-5 btn150px"
                          type="button"
                          onClick={() => onClickFome2Save()}
                        >
                          Next
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
              {selectedTab === 3 && (
                <Form>
                  <Row className="py-4">
                    <Col md={12} lg={6}>
                      <Form.Group className="pb-4">
                        <TextField
                          id="ticketName"
                          label="Ticket Name"
                          type="text"
                          variant="outlined"
                          className={`w-100 ${
                            formik3.errors.ticketName &&
                            formik3.touched.ticketName
                              ? "enError"
                              : ""
                          }`}
                          name="ticketName"
                          onChange={formik3.handleChange}
                          value={formik3.values.ticketName}
                          onBlur={formik3.handleBlur}
                        />
                        {formik3.errors.ticketName &&
                        formik3.touched.ticketName ? (
                          <div className="pho_14_regular text-danger">
                            {formik3.errors.ticketName}
                          </div>
                        ) : null}
                      </Form.Group>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="pb-4">
                            <NewInputText
                              extraClass="mb-1"
                              name="adult_price"
                              maxLength={5}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onInput={maxLengthCheck}
                              inputType="number"
                              onKeyDown={InputNumberFunc}
                              onFocusOut={formik3.handleBlur}
                              onChange={formik3.handleChange}
                              value={formik3.values.adult_price}
                              labelText="Adult Price"
                              controlClass="adult_price"
                            />
                            {formik3.errors.adult_price &&
                            formik3.touched.adult_price ? (
                              <div className="pho_14_regular text-danger">
                                {formik3.errors.adult_price}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        {formik1.values.isKidsAllowed ? (
                          <Col md={6}>
                            <Form.Group className="pb-4">
                              <NewInputText
                                extraClass="mb-1"
                                name="child_price"
                                maxLength={5}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                onInput={maxLengthCheck}
                                inputType="number"
                                onKeyDown={InputNumberFunc}
                                onFocusOut={formik3.handleBlur}
                                onChange={formik3.handleChange}
                                value={formik3.values.child_price}
                                labelText="Child Price"
                                controlClass="child_price"
                              />
                              {formik3.errors.child_price &&
                              formik3.touched.child_price ? (
                                <div className="pho_14_regular text-danger">
                                  {formik3.errors.child_price}
                                </div>
                              ) : null}
                            </Form.Group>
                          </Col>
                        ) : null}
                        <Col md={6}>
                          <Form.Group className="pb-4">
                            <NewInputText
                              extraClass="mb-1"
                              name="total_quantity_TB"
                              maxLength={5}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onInput={maxLengthCheck}
                              inputType="number"
                              onKeyDown={InputNumberFunc}
                              onFocusOut={formik3.handleBlur}
                              onChange={formik3.handleChange}
                              value={formik3.values.total_quantity_TB}
                              labelText="No. of tickets available"
                              controlClass="total_quantity_TB"
                            />
                            {formik3.errors.total_quantity_TB &&
                            formik3.touched.total_quantity_TB ? (
                              <div className="pho_14_regular text-danger">
                                {formik3.errors.total_quantity_TB}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={6} xs={6}>
                          <Form.Group className="pb-4">
                            <NewInputText
                              extraClass="mb-1"
                              name="buffer_TB_guest"
                              maxLength={5}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onInput={maxLengthCheck}
                              inputType="number"
                              onKeyDown={InputNumberFunc}
                              onFocusOut={formik3.handleBlur}
                              onChange={formik3.handleChange}
                              value={formik3.values.buffer_TB_guest}
                              labelText="No.of Buffer Guests"
                              controlClass="buffer_TB_guest"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="pb-4">
                            <NewInputText
                              extraClass="mb-1"
                              name="min_people_per_booking"
                              maxLength={5}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onInput={maxLengthCheck}
                              inputType="number"
                              onKeyDown={InputNumberFunc}
                              onFocusOut={formik3.handleBlur}
                              onChange={formik3.handleChange}
                              value={formik3.values.min_people_per_booking}
                              labelText="Minimum people per booking"
                              controlClass="min_people_per_booking"
                            />
                            {formik3.errors.min_people_per_booking &&
                            formik3.touched.min_people_per_booking ? (
                              <div className="pho_14_regular text-danger">
                                {formik3.errors.min_people_per_booking}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="pb-4">
                            <NewInputText
                              extraClass="mb-1"
                              name="max_people_per_booking"
                              maxLength={5}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onInput={maxLengthCheck}
                              inputType="number"
                              onKeyDown={InputNumberFunc}
                              onFocusOut={formik3.handleBlur}
                              onChange={formik3.handleChange}
                              value={formik3.values.max_people_per_booking}
                              labelText="Maximum people per booking"
                              controlClass="max_people_per_booking"
                            />
                            {formik3.errors.max_people_per_booking &&
                            formik3.touched.max_people_per_booking ? (
                              <div className="pho_14_regular text-danger">
                                {formik3.errors.max_people_per_booking}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="pb-4">
                            <TextField
                              id="ticket_description"
                              label="Ticket Description"
                              multiline
                              rows="5"
                              type="text"
                              variant="outlined"
                              className={`w-100 ${
                                formik3.errors.ticket_description &&
                                formik3.touched.ticket_description
                                  ? "enError"
                                  : ""
                              }`}
                              name="ticket_description"
                              onChange={formik3.handleChange}
                              value={formik3.values.ticket_description}
                              onBlur={formik3.handleBlur}
                            />
                            {formik3.errors.ticket_description &&
                            formik3.touched.ticket_description ? (
                              <div className="pho_14_regular text-danger">
                                {formik3.errors.ticket_description}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="pb-4">
                            <TextField
                              id="refund_and_cancellation"
                              label="Refund & cancellation"
                              multiline
                              rows="5"
                              type="text"
                              variant="outlined"
                              className={`w-100 ${
                                formik3.errors.refund_and_cancellation &&
                                formik3.touched.refund_and_cancellation
                                  ? "enError"
                                  : ""
                              }`}
                              name="refund_and_cancellation"
                              onChange={formik3.handleChange}
                              value={formik3.values.refund_and_cancellation}
                              onBlur={formik3.handleBlur}
                            />
                            {formik3.errors.refund_and_cancellation &&
                            formik3.touched.refund_and_cancellation ? (
                              <div className="pho_14_regular text-danger">
                                {formik3.errors.refund_and_cancellation}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <div className="py-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 btn150px"
                      type="button"
                      onClick={() => handleTab(2)}
                    >
                      Back
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5 btn150px"
                      type="button"
                      onClick={() => onClickFome3Save()}
                    >
                      Next
                    </Button>
                  </div>
                </Form>
              )}
              {selectedTab === 4 && (
                <Form>
                  <div className="f16-500 pb-4 mt-4">Assign Seating area</div>
                  <Row>
                    <Col xl={3} className="pb-4">
                      <FormControl variant="outlined" className={"w-100"}>
                        <InputLabel htmlFor="outlined-description">
                          Floor Number / Seating Area
                        </InputLabel>
                        <Select
                          value={formikAddNewFloorSeats.values.floor_number}
                          onChange={selectHandleChange}
                          label="Floor Number / Seating Area"
                          name="floor_number"
                          id="outlined-description"
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {!isEmpty(state.floor_numberArr) &&
                            state.floor_numberArr.map((allData, index) => {
                              return (
                                <MenuItem
                                  key={index}
                                  value={allData.floor_number}
                                >
                                  {allData.floor_number}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                    </Col>
                    <Col xl={3} className="pb-4">
                      <FormControl variant="outlined" className={"w-100"}>
                        <InputLabel htmlFor="outlined-description">
                          Section Name/Number
                        </InputLabel>
                        <Select
                          value={formikAddNewFloorSeats.values.area}
                          onChange={selectHandleChange2}
                          label="Section Name/Number"
                          name="area"
                          id="outlined-description"
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {!isEmpty(state.floor_numberArr) &&
                            state.floor_numberArr.map((allData, index) => {
                              return (
                                <MenuItem key={index} value={allData.area}>
                                  {allData.area}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                    </Col>
                    {formikAddNewFloorSeats.values.floor_number === undefined ||
                    (formikAddNewFloorSeats.values.area === undefined &&
                      formikAddNewFloorSeats.values.floor_number === "") ||
                    formikAddNewFloorSeats.values.area === "" ? null : (
                      <Col md={4}>
                        <Button
                          variant="link"
                          className="f16-400 d-flex align-items-center"
                          onClick={handleViewSeatingArea}
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/eye.svg")}
                            alt="View"
                            title="View"
                            className="w-20px"
                          />
                          <span className="pl-2">View</span>
                        </Button>
                      </Col>
                    )}
                  </Row>
                  <Button
                    variant="link"
                    className="d-flex align-items-center p-0 mb-4"
                    onClick={(e) => onClickAddFloor(e)}
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/add-blue.svg")}
                      alt="add"
                      title="add"
                      className="w-20px"
                    />
                    <span className="ml-2 f12-500 text-blue">
                      Add another Floor and Section details
                    </span>
                  </Button>
                  {formik4.values.floors.length !== 0 ? (
                    <div className="mt-5">
                      <Button
                        variant="link"
                        className="d-flex align-items-center text-red p-0 mb-4"
                        //onClick={handleToggleFloorsSection}
                        onClick={() => setShowHide(!showHide)}
                      >
                        <span className="f12-500 text-red">
                          {showHide ? "Hide" : "Show"} Floors and Sections
                        </span>
                        <KeyboardArrowDownIcon />
                      </Button>
                    </div>
                  ) : (
                    <> </>
                  )}
                  <div className="mb-5">
                    {formik4.values.floors.length !== 0 ? (
                      <>
                        {showHide ? (
                          <Row className="align-items-center">
                            <Col md={3}>
                              <div className="f16-500 py-2">Floor</div>
                            </Col>
                            <Col md={3}>
                              <div className="f16-500 py-2">Section</div>
                            </Col>
                          </Row>
                        ) : (
                          <> </>
                        )}
                      </>
                    ) : (
                      <> </>
                    )}
                    {showHide ? (
                      <React.Fragment>
                        {formik4.values.floors.map((data, index) => {
                          return (
                            <React.Fragment key={index}>
                              <Row className="align-items-center">
                                <Col md={3}>
                                  <div className="f14-400 py-2">
                                    {data.floor_number}
                                  </div>
                                </Col>
                                <Col md={3}>
                                  <div className="f14-400 py-2">
                                    {data.area}
                                  </div>
                                </Col>
                                <Col md={3}>
                                  <div className="d-flex align-items-center">
                                    <IconButton
                                      className="mr-2"
                                      onClick={(e) =>
                                        onClickEditFloorArea(data, index)
                                      }
                                    >
                                      <Image
                                        src={require("../../../../assets/images/UserManagement/editBlue.svg")}
                                        alt="edit "
                                        title="edit"
                                        className="w-20px"
                                      />
                                    </IconButton>
                                    <IconButton
                                      onClick={(e) =>
                                        handleshowDeleteItem(
                                          index,
                                          data.floor_number,
                                          data.area
                                        )
                                      }
                                    >
                                      <Image
                                        src={require("../../../../assets/images/UserManagement/delete-gray.svg")}
                                        alt="delete "
                                        title="delete"
                                        className="w-20px"
                                      />
                                    </IconButton>
                                  </div>
                                </Col>
                              </Row>
                            </React.Fragment>
                          );
                        })}
                      </React.Fragment>
                    ) : (
                      <></>
                    )}
                    {/* <Row>
                    <Col xl={3} className="pb-4">
                      <FormControl variant="outlined" className={"w-100"}>
                        <InputLabel htmlFor="outlined-description">
                          Floor Number / Seating Area
                        </InputLabel>
                        <Select
                          value={formikAddNewFloorSeats.values.floor_number}
                          onChange={selectHandleChange}
                          label="Floor Number / Seating Area"
                          name="floor_number"
                          id="outlined-description"
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {!isEmpty(state.floor_numberArr) &&
                            state.floor_numberArr.map((allData, index) => {
                              return (
                                <MenuItem
                                  key={index}
                                  value={allData.floor_number}
                                >
                                  {allData.floor_number}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                      {/* <NewInputText
                extraClass={`m-1 ${
                  formikAddNewFloorSeats.errors.floor_number &&
                  formikAddNewFloorSeats.touched.floor_number
                    ? "enError"
                    : ""
                }`}
                inputType="text"
                name="floor_number"
                labelText="Floor Number / Seating Area"
                onChange={formikAddNewFloorSeats.handleChange}
                value={formikAddNewFloorSeats.values.floor_number}
                onFocusOut={formikAddNewFloorSeats.handleBlur}
              />
              {formikAddNewFloorSeats.errors.floor_number &&
              formikAddNewFloorSeats.touched.floor_number ? (
                <div className="pho_14_regular text-danger">
                  {formikAddNewFloorSeats.errors.floor_number}
                </div>
              ) : null} *
                    </Col>
                    <Col xl={3} className="pb-4">
                      <FormControl variant="outlined" className={"w-100"}>
                        <InputLabel htmlFor="outlined-description">
                          Section Name/Number
                        </InputLabel>
                        <Select
                          value={formikAddNewFloorSeats.values.area}
                          onChange={selectHandleChange2}
                          label="Section Name/Number"
                          name="area"
                          id="outlined-description"
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {!isEmpty(state.floor_numberArr) &&
                            state.floor_numberArr.map((allData, index) => {
                              return (
                                <MenuItem key={index} value={allData.area}>
                                  {allData.area}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                      {/* <NewInputText
                extraClass={`m-1 ${
                  formikAddNewFloorSeats.errors.area &&
                  formikAddNewFloorSeats.touched.area
                    ? "enError"
                    : ""
                }`}
                inputType="text"
                name="area"
                labelText="Section Name/Number"
                onChange={formikAddNewFloorSeats.handleChange}
                value={formikAddNewFloorSeats.values.area}
                onFocusOut={formikAddNewFloorSeats.handleBlur}
              />
              {formikAddNewFloorSeats.errors.area &&
              formikAddNewFloorSeats.touched.area ? (
                <div className="pho_14_regular text-danger">
                  {formikAddNewFloorSeats.errors.area}
                </div>
              ) : null} *
                    </Col>
                    {formikAddNewFloorSeats.values.floor_number === undefined ||
                    (formikAddNewFloorSeats.values.area === undefined &&
                      formikAddNewFloorSeats.values.floor_number === "") ||
                    formikAddNewFloorSeats.values.area === "" ? null : (
                      <Col md={4}>
                        <Button
                          variant="link"
                          className="f16-400 d-flex align-items-center"
                          onClick={handleViewSeatingArea}
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/eye.svg")}
                            alt="View"
                            title="View"
                            className="w-20px"
                          />
                          <span className="pl-2">View</span>
                        </Button>
                      </Col>
                    )}
                    {/* <Col xl={3} className="pb-4">
                      <NewInputText
                        extraClass={`m-1 ${
                          formikAddNewFloorSeats.errors.floor_number &&
                          formikAddNewFloorSeats.touched.floor_number
                            ? "enError"
                            : ""
                        }`}
                        inputType="text"
                        name="floor_number"
                        labelText="Floor Number / Seating Area"
                        onChange={formikAddNewFloorSeats.handleChange}
                        value={formikAddNewFloorSeats.values.floor_number}
                        onFocusOut={formikAddNewFloorSeats.handleBlur}
                      />
                      {formikAddNewFloorSeats.errors.floor_number &&
                      formikAddNewFloorSeats.touched.floor_number ? (
                        <div className="pho_14_regular text-danger">
                          {formikAddNewFloorSeats.errors.floor_number}
                        </div>
                      ) : null}
                    </Col>
                    <Col xl={3} className="pb-4">
                      <NewInputText
                        extraClass={`m-1 ${
                          formikAddNewFloorSeats.errors.area &&
                          formikAddNewFloorSeats.touched.area
                            ? "enError"
                            : ""
                        }`}
                        inputType="text"
                        name="area"
                        labelText="Section Name/Number"
                        onChange={formikAddNewFloorSeats.handleChange}
                        value={formikAddNewFloorSeats.values.area}
                        onFocusOut={formikAddNewFloorSeats.handleBlur}
                      />
                      {formikAddNewFloorSeats.errors.area &&
                      formikAddNewFloorSeats.touched.area ? (
                        <div className="pho_14_regular text-danger">
                          {formikAddNewFloorSeats.errors.area}
                        </div>
                      ) : null}
                    </Col> *
                  </Row>
                  <Button
                    variant="link"
                    className="d-flex align-items-center p-0 mb-4"
                    onClick={(e) => onClickAddFloor(e)}
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/add-blue.svg")}
                      alt="add"
                      title="add"
                      className="w-20px"
                    />
                    <span className="ml-2 f12-500 text-blue">
                      Add another Floor and Section details
                    </span>
                  </Button>
                  {formik4.values.floors.length !== 0 ? (
                    <div className="mt-5">
                      <Button
                        variant="link"
                        className="d-flex align-items-center text-red p-0 mb-4"
                        //onClick={handleToggleFloorsSection}
                        onClick={() => setShowHide(!showHide)}
                      >
                        <span className="f12-500 text-red">
                          {showHide ? "Hide" : "Show"} Floors and Sections
                        </span>
                        <KeyboardArrowDownIcon />
                      </Button>
                    </div>
                  ) : (
                    <> </>
                  )}
                  <div className="mb-5">
                    {formik4.values.floors.length !== 0 ? (
                      <>
                        {showHide ? (
                          <Row className="align-items-center">
                            <Col>
                              <div className="f16-500 py-2">Floor</div>
                            </Col>
                            <Col>
                              <div className="f16-500 py-2">Section</div>
                            </Col>
                            <Col>
                              <></>
                            </Col>
                          </Row>
                        ) : (
                          <> </>
                        )}
                      </>
                    ) : (
                      <> </>
                    )}
                    {showHide ? (
                      <React.Fragment>
                        {formik4.values.floors.map((data, index) => {
                          return (
                            <React.Fragment key={index}>
                              <Row className="align-items-center">
                                <Col>
                                  <div className="f14-400 py-2">
                                    {data.floor_number}
                                  </div>
                                </Col>
                                <Col>
                                  <div className="f14-400 py-2">
                                    {data.area}
                                  </div>
                                </Col>
                                <Col>
                                  <div className="d-flex align-items-center">
                                    <IconButton
                                      className="mr-2"
                                      onClick={(e) =>
                                        onClickEditFloorArea(data, index)
                                      }
                                    >
                                      <Image
                                        src={require("../../../../assets/images/UserManagement/editBlue.svg")}
                                        alt="edit "
                                        title="edit"
                                        className="w-20px"
                                      />
                                    </IconButton>
                                    <IconButton
                                      onClick={(e) =>
                                        handleshowDeleteItem(
                                          index,
                                          data.floor_number,
                                          data.area
                                        )
                                      }
                                    >
                                      <Image
                                        src={require("../../../../assets/images/UserManagement/delete-gray.svg")}
                                        alt="delete "
                                        title="delete"
                                        className="w-20px"
                                      />
                                    </IconButton>
                                  </div>
                                </Col>
                              </Row>
                            </React.Fragment>
                          );
                        })}
                      </React.Fragment>
                    ) : (
                      <></>
                    )}
                  </div> */}
                  </div>
                  <div className="row">
                    <div className="col-8 col-md-4 col-sm-6 col-xs-6">
                      <h2 className="f14-500">Seat selection applicable</h2>
                      <p className="f11-400">
                        (Enable this toggle if you want to give seat selection
                        option to the user)
                      </p>
                    </div>
                    {formik4.values.ticket_seat_selection}
                    <div className="col-4 col-md-4 col-sm-6 col-xs-6">
                      <div className="d-flex align-items-center">
                        <div
                          className={`${
                            !formik4.values.ticket_seat_selection
                              ? "f12-500"
                              : "f12-400"
                          } mr-2`}
                        >
                          No
                        </div>
                        <AntSwitch
                          checked={formik4.values.ticket_seat_selection}
                          onChange={() => onClickSeatSelectionAction()}
                          name="checkedC"
                        />
                        <div
                          className={`${
                            formik4.values.ticket_seat_selection
                              ? "f12-500"
                              : "f12-400"
                          } ml-2`}
                        >
                          Yes
                        </div>
                      </div>
                    </div>
                  </div>

                  <Modal
                    show={deleteItem}
                    onHide={handleCloseDeleteItem}
                    centered
                  >
                    <Modal.Header className="py-0 pt-2 border-0" closeButton>
                      <Modal.Title></Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="f16-500">
                      Are you sure to delete this floor/section ?
                    </Modal.Body>
                    <Modal.Footer className="justify-content-start border-0">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5"
                        onClick={handleCloseDeleteItem}
                      >
                        No
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5"
                        onClick={removeFloorAndSection}
                      >
                        Yes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <div className="py-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 btn150px"
                      type="button"
                      onClick={() => handleTab(3)}
                    >
                      Back
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5 btn150px"
                      type="button"
                      onClick={() => onClickFome4Save()}
                    >
                      Next
                    </Button>
                  </div>
                  {/* <div className="onboarding-map-setup-screen-autodetect-button ">
                    <ReusableOnboardingButton
                      buttonTitle="Back Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      buttonText="Back"
                      buttonType="button"
                      onClick={() => handleTab(3)}
                    />
                    <ReusableOnboardingButton
                      buttonTitle="Next Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                      buttonText="Next"
                      buttonType="button"
                      onClick={() => onClickFome4Save()}
                    />
                  </div> */}
                </Form>
              )}
              {selectedTab === 5 && (
                <Form>
                  <div className="f20-700 text-dark mt-4 mb-5">
                    Do you provide services for the following at the Events?
                  </div>
                  <div className="row margin-between-toggler mb-4 pt-2">
                    <div className="col-4">
                      <div>
                        <div className="f15-700">Highchair</div>
                        <p className="left-toggle-bottom-text-head"></p>
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="d-flex align-items-center">
                        <div
                          className={`${
                            !state.highchair ? "f12-500" : "f12-400"
                          } mr-2`}
                        >
                          No
                        </div>
                        <Switch
                          onChange={() =>
                            setState({
                              ...state,
                              highchair: !state.highchair,
                            })
                          }
                          checked={state.highchair}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                        />
                        <div
                          className={`${
                            state.highchair ? "f12-500" : "f12-400"
                          } ml-2`}
                        >
                          Yes
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row margin-between-toggler mb-4 pt-2">
                    <div className="col-4">
                      <div className="f15-700">Handicap Access</div>
                    </div>
                    <div className="col-2">
                      <div className="d-flex align-items-center">
                        <div
                          className={`${
                            !state.handicap_access ? "f12-500" : "f12-400"
                          } mr-2`}
                        >
                          No
                        </div>
                        <Switch
                          onChange={() =>
                            setState({
                              ...state,
                              handicap_access: !state.handicap_access,
                            })
                          }
                          checked={state.handicap_access}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                        />
                        <div
                          className={`${
                            state.handicap_access ? "f12-500" : "f12-400"
                          } ml-2`}
                        >
                          Yes
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row margin-between-toggler mb-4 pt-2">
                    <div className="col-4">
                      <div className="f15-700">
                        Room number on Seating Request?
                      </div>
                      <div className="f11-400 opacity5">
                        (This may be relevant if you located inside a
                        hotel/resort)
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="d-flex align-items-center">
                        <div
                          className={`${
                            !state.room_on_seating_rq ? "f12-500" : "f12-400"
                          } mr-2`}
                        >
                          No
                        </div>
                        <Switch
                          onChange={() =>
                            setState({
                              ...state,
                              room_on_seating_rq: !state.room_on_seating_rq,
                            })
                          }
                          checked={state.room_on_seating_rq}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                        />
                        <div
                          className={`${
                            state.room_on_seating_rq ? "f12-500" : "f12-400"
                          } ml-2`}
                        >
                          Yes
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row margin-between-toggler">
                    <div className="col-4">
                      <div className="f15-700">Auto Accept Pax Limit</div>
                      <div className="f11-400 opacity5">
                        (Request with pax below this will automatically be
                        accepted for RSVP, any number above this threshold will
                        go to pending for action)
                      </div>
                    </div>
                    <div className="col-3">
                      <NewInputText
                        extraClass="mb-1"
                        name="auto_accept_pax"
                        maxLength={5}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        onInput={maxLengthCheck}
                        inputType="number"
                        onKeyDown={InputNumberFunc}
                        onFocusOut={formik5.handleBlur}
                        onChange={formik5.handleChange}
                        value={formik5.values.auto_accept_pax}
                        labelText="Pax"
                        controlClass="auto_accept_pax"
                      />
                      {formik5.errors.auto_accept_pax &&
                      formik5.touched.auto_accept_pax ? (
                        <div className="pho_14_regular text-danger">
                          {formik5.errors.auto_accept_pax}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="py-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 btn150px"
                      onClick={
                        editData?.ticket_booking_subscription
                          ? () => handleTab(4)
                          : () => handleTab(2)
                      }
                    >
                      Back
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5 btn150px"
                      type="button"
                      onClick={(e) => onClickFome5Save(e)}
                    >
                      Done
                    </Button>
                  </div>
                </Form>
              )}
              <Modal
                show={viewSeatingArea}
                onHide={handleViewSeatingArea}
                centered
                size="lg"
              >
                <Modal.Header className="py-0 pt-2 border-0" closeButton>
                  <Modal.Title>View Seat</Modal.Title>
                </Modal.Header>
                <Modal.Body className="f16-500">
                  <React.Fragment>
                    <Scrollbars
                      style={{
                        width: "100%",
                        height: 400,
                        border: "1px solid #dee2e6",
                        borderRadius: 11,
                      }}
                    >
                      <div className="enTableArrangement table-responsive">
                        <Table className="w-100">
                          <thead>
                            <tr>
                              <th className="f12-700">Floor</th>
                              <th className="f12-700">Section</th>
                              <th className="f12-700">No.</th>
                              <th className="f12-700">Shape</th>
                              <th className="f12-700">Capacity</th>
                              <th className="f12-700">Location</th>
                              <th className="f12-700">Status</th>
                              {/* <th className="f12-700">Actions</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {/* filteredTableDataDashboard
                  filteredSeatDataDashboard */}
                            {onModalTableData()}
                          </tbody>
                        </Table>
                      </div>
                    </Scrollbars>
                  </React.Fragment>
                </Modal.Body>
                <Modal.Footer className="justify-content-start border-0">
                  {/* <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            // onClick={handleCloseDeleteItem}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            // onClick={removeFloorAndSection}
          >
            Yes
          </Button> */}
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

VendorEditOfflineEvent.propTypes = {
  auth: PropTypes.object.isRequired,
  vendor_update_events: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  onboarding: state.onboarding.restaurantDetails,
  subscriptionData:
    state.onboarding && state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, { vendor_update_events })(
  VendorEditOfflineEvent
);
